import { BIModel } from './BIModel';

export class MKTShareCollectionBIModel extends BIModel {

  static eventName = 'MKT_share_collection';

  #flow;
  #collectionName;
  #channel;

  constructor(userId, flow, collectionName, channel) {
    super(MKTShareCollectionBIModel.eventName, userId);
    this.#flow = flow;
    this.#collectionName = collectionName;
    this.#channel = channel;
  }

  get flow() {
    return this.#flow;
  }

  get collectionName() {
    return this.#collectionName;
  }

  get channel() {
    return this.#channel;
  }

  get modelData() {
    return {
      flow: this.flow,
      collection_name: this.collectionName,
      channel: this.channel,
    };
  }

}